/* ARCA shop menu: tab switching and card carousel arrows */
if (!customElements.get('arca-shop-menu')) {
  class ArcaShopMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          this.select(index);
        });
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.querySelectorAll('.arca-shop__track-wrap').forEach((wrap) => this.setupCarousel(wrap));
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next, true);
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });

      const tab = this.tabs[index];
      if (focus && tab) tab.focus();

      const tabList = tab && tab.parentElement;
      if (tabList && tabList.scrollWidth > tabList.clientWidth) {
        const left = tab.offsetLeft - (tabList.clientWidth - tab.offsetWidth) / 2;
        tabList.scrollTo({ left, behavior: 'smooth' });
      }

      const wrap = this.panels[index] && this.panels[index].querySelector('.arca-shop__track-wrap');
      if (wrap && wrap.arcaUpdate) {
        const track = wrap.querySelector('.arca-shop__track');
        if (track) track.scrollLeft = 0;
        wrap.arcaUpdate();
      }
    }

    setupCarousel(wrap) {
      const track = wrap.querySelector('.arca-shop__track');
      const prev = wrap.querySelector('[data-dir="-1"]');
      const next = wrap.querySelector('[data-dir="1"]');
      if (!track || !prev || !next) return;

      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = max <= 0 || track.scrollLeft >= max;
      };
      wrap.arcaUpdate = update;

      [prev, next].forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const item = track.querySelector('.arca-shop__item');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
          track.scrollBy({ left: step * Number(button.dataset.dir), behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    }
  }

  customElements.define('arca-shop-menu', ArcaShopMenu);
}
